/* assets/global.js */
/* JS base Terral (adaptado desde la demo) :contentReference[oaicite:3]{index=3} */

(function () {
  "use strict";

  const onReady = (fn) => {
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", fn);
    else fn();
  };

  onReady(() => {
    // Año en footer (si existe)
    const yearEl = document.getElementById("year");
    if (yearEl) yearEl.textContent = new Date().getFullYear();

    // =========================
    // Buscador NAV (popover simple)
    // (lo conectaremos cuando exista el HTML del header)
    // =========================
    const openBtn = document.getElementById("openSearch");
    const pop = document.getElementById("navSearch");
    const closeBtn = document.querySelector(".nav-search-close");

    const closePop = () => pop && pop.classList.remove("show");

    if (openBtn && pop) {
      openBtn.addEventListener("click", () => {
        pop.classList.toggle("show");
        const input = document.getElementById("searchInput");
        if (pop.classList.contains("show") && input) input.focus();
      });
    }
    if (closeBtn) closeBtn.addEventListener("click", closePop);
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") closePop();
    });
    document.addEventListener("click", (e) => {
      if (!pop || !pop.classList.contains("show")) return;
      const within = pop.contains(e.target) || (openBtn && openBtn.contains(e.target));
      if (!within) closePop();
    });

    // =========================
    // KPIs count-up (si existen .stat-value[data-target])
    // =========================
    const easeOut = (t) => 1 - Math.pow(1 - t, 3);
    const animateCount = (el) => {
      const target = Number(el.dataset.target || 0);
      const duration = 1200;
      let start = null;

      const step = (ts) => {
        if (!start) start = ts;
        const p = Math.min((ts - start) / duration, 1);
        const val = Math.floor(easeOut(p) * target);
        el.textContent = val.toLocaleString("es-ES");
        if (p < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    };
    document.querySelectorAll(".stat-value[data-target]").forEach(animateCount);

    // =========================
    // Donuts SIN Chart.js:
    // Si existe <canvas data-donut="100"> lo pintamos
    // =========================
    const drawDonut = (canvas, percent) => {
      const ctx = canvas.getContext("2d");
      if (!ctx) return;

      const dpr = window.devicePixelRatio || 1;
      const cssSize = Math.min(canvas.clientWidth || 240, canvas.clientHeight || 240, 320);
      canvas.width = Math.floor(cssSize * dpr);
      canvas.height = Math.floor(cssSize * dpr);
      ctx.scale(dpr, dpr);

      const w = cssSize;
      const h = cssSize;
      const cx = w / 2;
      const cy = h / 2;

      const radius = Math.min(w, h) * 0.39; // similar a radius 78% visualmente
      const thickness = Math.max(10, Math.min(18, w * 0.07)); // aro fino

      const start = -Math.PI / 2;
      const end = start + (Math.PI * 2 * (percent / 100));

      // fondo
      ctx.clearRect(0, 0, w, h);
      ctx.lineWidth = thickness;
      ctx.lineCap = "round";

      ctx.beginPath();
      ctx.strokeStyle = "rgba(0,0,0,.08)";
      ctx.arc(cx, cy, radius, 0, Math.PI * 2);
      ctx.stroke();

      // progreso
      ctx.beginPath();
      ctx.strokeStyle = "#C41130";
      ctx.arc(cx, cy, radius, start, end);
      ctx.stroke();

      // texto
      const fontSize = Math.max(16, Math.min(28, w * 0.12));
      ctx.fillStyle = "#111";
      ctx.font = `700 ${fontSize}px Poppins, system-ui, sans-serif`;
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.fillText(`${percent}%`, cx, cy);
    };

    const paintAllDonuts = () => {
      document.querySelectorAll("canvas[data-donut]").forEach((c) => {
        const p = Number(c.getAttribute("data-donut") || "0");
        drawDonut(c, Math.max(0, Math.min(100, p)));
      });
    };
    paintAllDonuts();
    window.addEventListener("resize", paintAllDonuts);

    // =========================
    // About tabs (si existen .about-tab2 y templates)
    // =========================
    (function () {
      const textEl = document.getElementById("about-terral-text");
      if (!textEl) return;

      const btns = document.querySelectorAll(".about-tab2");
      const tpl = {
        vision: document.getElementById("tpl-vision"),
        mision: document.getElementById("tpl-mision"),
        objetivos: document.getElementById("tpl-objetivos"),
      };

      const setFromTemplate = (t) => {
        if (!t) return;
        textEl.innerHTML = t.innerHTML.trim();
      };

      setFromTemplate(tpl.vision);

      btns.forEach((btn) => {
        btn.addEventListener("click", () => {
          btns.forEach((b) => b.classList.remove("active"));
          btn.classList.add("active");
          setFromTemplate(tpl[btn.dataset.target]);
        });
      });
    })();

    // =========================
    // Contacto: validación HTML5 + mensaje OK (si existe)
    // =========================
    (function () {
      const form = document.getElementById("contactForm");
      if (!form) return;

      form.addEventListener("submit", function (e) {
        if (form.elements.empresa && form.elements.empresa.value) {
          e.preventDefault();
          return;
        }

        if (!form.checkValidity()) {
          e.preventDefault();
          e.stopPropagation();
          form.classList.add("was-validated");
          return;
        }

        e.preventDefault();
        form.classList.remove("was-validated");
        form.reset();

        const ok = document.getElementById("contactSuccess");
        if (ok) {
          ok.classList.remove("d-none");
          setTimeout(() => ok.classList.add("d-none"), 5000);
        }
      });
    })();
  });
})();
